import { envConfig } from "../constants/api-endpoint";
import { COOKIE, FILTER_NAMES, countries } from "../constants/app-constant";
import { getCookie } from "../utility/cookieProvider";
import {
  SET_EDITION_LIST,
  SET_PUBLICATION_TYPES,
  SET_ZONES,
  SET_CATEGORY,
  SET_REPORTERS,
  SET_ENTITY_LIST,
  SET_CLIENT_LIST,
  SET_PUBLICATION,
  SET_PRESS_RELEASE,
  SET_SOCIAL_ENTITY_LIST,
  SET_REPORTS_ENTITY_LIST,
  RESET_PUBLICATIONS,
  SET_CHANNEL_TYPE,
  SET_REPORTS_FOR_TV,
  SET_LANGUAGES,
  SET_COUNTRY,
  SET_CHART_TYPE,
} from "./actionTypes";
import { httpGet, httpPost } from "../utility/requestHelper";
import { getConceptUserId } from "../utility/common-methods";

const {
  EDITION,
  PUBLICATION_TYPE,
  CATEGORY,
  ZONE,
  REPORTER,
  ENTITY,
  CLIENT,
  PUBLICATION,
  PRESS_RELEASE,
  SOCIAL_ENTITY,
  REPORTS_ENTITY,
  CHANNELS_LIST,
  REPORT_LIST,
  LANGUAGE_LIST,
  COUNTRY_LIST,
} = FILTER_NAMES;

const lowerCaseEdition = EDITION.toLowerCase();
const lowerCasePublicationType = PUBLICATION_TYPE.toLowerCase();
const lowerCasePublication = PUBLICATION.toLowerCase();
const lowerCaseCategory = CATEGORY.toLowerCase();
const lowerCaseZone = ZONE.toLowerCase();
const lowerCaseReporter = REPORTER.toLowerCase();
const lowerCaseEntity = ENTITY.toLowerCase();
const lowerCaseReportsEntity = REPORTS_ENTITY.toLowerCase();
const lowerCaseSocialEntity = SOCIAL_ENTITY.toLowerCase();
const lowerCaseClient = CLIENT.toLowerCase();
const lowerCasePressRelease = PRESS_RELEASE.toLowerCase();
const channelList = CHANNELS_LIST.toLowerCase()
const reporterList = REPORT_LIST.toLowerCase()
const languageList = LANGUAGE_LIST.toLowerCase()
const countryList = COUNTRY_LIST.toLowerCase()

const setFilters = (payload, filterType) => {
  switch (filterType) {

    case lowerCasePublicationType:
      return {
        type: SET_PUBLICATION_TYPES,
        publication_type: payload,
      };

    case lowerCaseEdition:
      return {
        type: SET_EDITION_LIST,
        edition: payload,
      };

    case lowerCaseZone:
      return {
        type: SET_ZONES,
        zone: payload,
      };

    case lowerCaseCategory:
      return {
        type: SET_CATEGORY,
        category: payload,
      };

    case lowerCaseReporter:
      return {
        type: SET_REPORTERS,
        reporter: payload,
      };
    case lowerCaseEntity:
      return {
        type: SET_ENTITY_LIST,
        entity: payload,
      };
    case lowerCaseReportsEntity:
      return {
        type: SET_REPORTS_ENTITY_LIST,
        reportsEntity: payload,
      };
    case lowerCaseClient:
      return {
        type: SET_CLIENT_LIST,
        clients: payload,
      };
    case lowerCasePublication:
      return {
        type: SET_PUBLICATION,
        publications: payload,
      };
    case lowerCasePressRelease:
      return {
        type: SET_PRESS_RELEASE,
        press_release: payload,
      };
    case lowerCaseSocialEntity:
      return {
        type: SET_SOCIAL_ENTITY_LIST,
        socialEntity: payload,
      };
    case channelList:
      return {
        type: SET_CHANNEL_TYPE,
        channels: payload,
      };
    case reporterList:
      return {
        type: SET_REPORTS_FOR_TV,
        reports: payload,
      };
    case languageList:
      return {
        type: SET_LANGUAGES,
        languages: payload,
      };
    case countryList:
      return {
        type: SET_COUNTRY,
        countrys: payload,
      };  
    default:
  }
};

export const fetchPublicationIds = (mediaType = 0) => {
  return (dispatch) => {
    dispatch(setFilters([], lowerCasePublicationType));
    httpPost(`${envConfig.PUBLICATION_TYPES_LIST}`, {
      media_type: mediaType,
    }).then((res) => {
      const {
        data: { result },
      } = res || {};
      dispatch(setFilters(result, lowerCasePublicationType));
    });
  };
};

export const resetPublications = () => {
  return {
    type: RESET_PUBLICATIONS,
  };
};

const fetchEditionsList = (clientId) => {
  return (dispatch) => {
    httpPost(`${envConfig.EDITIONS_LIST}`, {
      client_id: clientId,
      user_id: getConceptUserId(),
    }).then((res) => {
      const {
        data: { result },
      } = res || {};
      dispatch(setFilters(result, lowerCaseEdition));
    });
  };
};

const fetchZoneList = () => {
  return (dispatch) => {
    httpPost(`${envConfig.ZONES}`, {}).then((res) => {
      const {
        data: { result },
      } = res || {};
      dispatch(setFilters(result, lowerCaseZone));
    });
  };
};

//TODO: confirm body param and continue.
export const fetchReporterList = (source_type, keyword) => {
  return (dispatch) => {
    httpPost(`${envConfig.REPORTER_SEARCH}`, {
      keyword,
      reporter_type: "all",
    }).then((res) => {
      const {
        data: { result },
      } = res || {};
      dispatch(setFilters(result, lowerCaseReporter));
    });
  };
};

const fetchCategoryList = (clientId) => {
  return (dispatch) => {
    httpPost(`${envConfig.CATEGORIES}`, {
      client_id: clientId,
    }).then((res) => {
      const {
        data: { result },
      } = res || {};
      dispatch(setFilters(result, lowerCaseCategory));
    });
  };
};

export const setReportsEntityList = (list) => {
  return (dispatch) => {
    dispatch(setFilters(list, lowerCaseReportsEntity));
  };
};

export const setEntityList = (list) => {
  return (dispatch) => {
    dispatch(setFilters(list, lowerCaseEntity));
  };
};

export const setSocialEntityList = (list) => {
  return (dispatch) => {
    dispatch(setFilters(list, lowerCaseSocialEntity));
  };
};

export const setClientList = (list) => {
  return (dispatch) => {
    dispatch(setFilters(list, lowerCaseClient));
  };
};

export const fetchPublications = (
  client_id,
  edition_id,
  keyword,
  media_type,
  publication_type
) => {
  if (!publication_type) {
    return {
      type: "No publication type",
    };
  }
  return (dispatch) => {
    httpPost(`${envConfig.PUBLICATION_SEARCH}`, {
      client_id,
      edition_id,
      keyword,
      media_type,
      publication_type,
    }).then((res) => {
      const {
        data: { status, result },
      } = res || {};
      // eslint-disable-next-line
      if (status == 200) {
        dispatch(setFilters(result, lowerCasePublication));
      } else if (status == 404) {
        dispatch(setFilters([], lowerCasePublication));
      }
    });
  };
};

export const fetchPressRelease = (clientId) => {
  return (dispatch) => {
    clientId &&
      httpPost(`${envConfig.PRESS_RELEASE}`, {
        client_id: clientId,
      }).then((res) => {
        const {
          data: { result },
        } = res || {};
        dispatch(setFilters(result, lowerCasePressRelease));
      });
  };
};
export const fetchChannels = () => {
  return (dispatch) => {
    httpPost(`${envConfig.CHANNELS_LIST}`).then((res) => {
      const {
        data: { result },
      } = res || {};
      dispatch(setFilters(result, channelList));
    });
  };
};
export const fetchJounalist = () => {
  return (dispatch) => {
    httpPost(`${envConfig.REPORT_LIST}`).then((res) => {
      const {
        data: { result },
      } = res || {};
      dispatch(setFilters(result, reporterList));
    });
  };
};

export const fetchLanguages = () => {
  return (dispatch) => {
    httpPost(`${envConfig.LANGUAGES_LIST}`).then((res) => {
      const {
        data: { result },
      } = res || {};
      dispatch(setFilters(result, languageList));
    })
    .catch((err) => {
      console.log("Language Fetch Failed: ", err);
    });
  };
};

export const fetchCountry = () => {
  return (dispatch) => {
    dispatch(setFilters(countries, countryList));
  };
};

export const initFilters = ({ clientId }) => {
  return (dispatch) => {
    dispatch(fetchEditionsList(clientId));
    dispatch(fetchCategoryList(clientId));
    dispatch(fetchZoneList());
    dispatch(fetchLanguages());
    dispatch(fetchJounalist());
    dispatch(fetchChannels());
    //dispatch(fetchCountry());
  };
};
